// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"7a2cab91","506":"b05cfcb0","769":"c3a8b139","948":"5a8626a5"}[chunkId] + ".chunk.js";
};